<template>

    <m-edit1/>

    <m-wallet-1 v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>default   </template>
                </m-wallet-1>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mWallet1 from '@moeinmdn/miw-alpha-components/src/package/Wallet/Wallets/Wallet1/Wallet1';

export default {
    name: 'HomeView',
    components: {mEdit1, mWallet1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
